module.exports = __webpack_public_path__ + "42deba0ac92ac92816818c9642984629.pdf";